<template>
    <div class="text-center">
        <v-window v-model="stepper">
            <v-window-item v-for="(person, index) in persons" :key="index">
                <v-row>
                    <v-col cols="12" class="text-center">
                        <div class="display-1 white--text">
                            Jij bent {{person.percentage}}%
                            <span class="text-capitalize">{{person.name}}</span></div>
                    </v-col>
                </v-row>
                <v-col style="width: 40vh" class="mx-auto">
                    <v-row justify="center">
                        <VImg :src="require(`@/assets/kingscoders/${person.name}.jpg`)" aspect-ratio="1"/>
                    </v-row>
                </v-col>
                <v-row>
                    <v-col cols="12" class="text-center white--text">
                        {{descriptions[person.name]}}
                    </v-col>
                </v-row>
            </v-window-item>
        </v-window>
        <v-row justify="center" class="mt-6">
            <v-btn color="secondary" text @click="stepper === 0 ? stepper = persons.length -1 : stepper--"><</v-btn>
            <VSpacer/>
            <v-btn color="secondary primary--text font-weight-bold" :to="{name: 'home'}">Speel opnieuw</v-btn>
            <VSpacer/>
            <v-btn color="secondary" text @click="stepper++">></v-btn>
        </v-row>
    </div>
</template>

<script>
import descriptions from '../quiz/descriptions.js';
import {whoAmI} from '../quiz/quiz.js';

export default {
    name: 'Outro',
    data() {
        return {
            persons: [],
            stepper: 0,
        };
    },
    computed: {
        descriptions() {
            return descriptions;
        },
    },
    created() {
        this.persons = whoAmI(Object.values(this.$route.query));
    },
};
</script>

<style scoped>

</style>
